import {
  panelPointerMovePerfBeginHandler,
  panelPointerMovePerfEndHandler
} from '../../utils/panelPointerMovePerfLog.js';

/**
 * 맵 커서 플러그인 — 그리기/복사/줌/드래그 커서 (패널 플래닝·공통 맵 재사용)
 *
 * ctx:
 *   getTargetElement?: () => HTMLElement|null
 *   getDrawingActive?: () => boolean
 *   getCopyModifierActive?: () => boolean
 *   getVectorLayer?: () => import('ol/layer/Layer').default|null
 */
export const mapCursorPlugin = {
  id: 'map-cursor',

  attach(host, ctx = {}) {
    const map = host.getMap();
    if (!map) {
      return;
    }

    const getEl = () => {
      if (typeof ctx.getTargetElement === 'function') {
        return ctx.getTargetElement();
      }
      const id = host.targetId;
      return id ? document.getElementById(id) : null;
    };

    const getVectorLayer = () => {
      if (typeof ctx.getVectorLayer === 'function') {
        return ctx.getVectorLayer();
      }
      return host.getVectorLayer();
    };

    let zoomCursorTimer = null;

    const onPointerMove = event => {
      const perf = panelPointerMovePerfBeginHandler('map-cursor');
      const el = getEl();
      if (!el) {
        panelPointerMovePerfEndHandler(perf);
        return;
      }
      if (ctx.getDrawingActive?.()) {
        el.style.cursor = 'crosshair';
        panelPointerMovePerfEndHandler(perf);
        return;
      }
      const oe = event.originalEvent;
      if (oe?.ctrlKey || oe?.metaKey || ctx.getCopyModifierActive?.()) {
        el.style.cursor = 'copy';
        panelPointerMovePerfEndHandler(perf);
        return;
      }
      el.style.cursor = 'default';
      panelPointerMovePerfEndHandler(perf);
    };

    map.on('pointermove', onPointerMove);

    return () => {
      map.un('pointermove', onPointerMove);
    };
  }
};
